import React from "react";
import CampaignDetailsModal from "./CampaignDetailsModal";
import { SectionCard, DataTable } from "../scraper";
import SmartPagination from "../SmartPagination";

const STATUS_STYLES = {
    COMPLETED: "bg-green-100 text-green-700 border-green-200",
    FAILED: "bg-red-100 text-red-600 border-red-200",
    IN_PROGRESS: "bg-blue-100 text-blue-700 border-blue-200",
    PENDING: "bg-amber-100 text-amber-700 border-amber-200",
};

const StatusBadge = ({ status }) => (
    <span
        className={`
            inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold border
            ${STATUS_STYLES[status] || "bg-gray-100 text-gray-600 border-gray-200"}
        `}
    >
        {status}
    </span>
);

const ChipList = ({ items, color }) => {
    if (!items?.length) return <span className="text-gray-400">—</span>;
    return (
        <div className="flex flex-wrap gap-1" style={{ maxWidth: 160 }}>
            {items.slice(0, 3).map((cat) => (
                <span key={cat} className={`px-1.5 py-0.5 rounded text-xs font-medium ${color}`}>
                    {cat}
                </span>
            ))}
            {items.length > 3 && (
                <span className="text-xs text-gray-400">+{items.length - 3}</span>
            )}
        </div>
    );
};

const HistoryTable = ({ history, currentPage, onPageChange }) => {

    const [selectedCampaign, setSelectedCampaign] = React.useState(null);
    if (!history) return null;


    const openDetails = (campaign) => {
        setSelectedCampaign(campaign);
    };

    const closeDetails = () => {
        setSelectedCampaign(null);
    };

    const columns = [

        {
            key: "created_at",
            label: "Date",
            render: (_, row) => (
                new Date(row.created_at).toLocaleString()
            )
        },

        {
            key: "subject",
            label: "Subject",
        },

        {
            key: "status",
            label: "Status",
            render: (_, row) => (
                <StatusBadge status={row.status} />
            )
        },

        {
            key: "total",
            label: "Sent",
        },

        {
            key: "success",
            label: "Success",
            render: (_, row) => (
                <span className="font-semibold text-green-600">
                    {row.success}
                </span>
            )
        },

        {
            key: "failed",
            label: "Failed",
            render: (_, row) => (
                <span className="font-semibold text-red-500">
                    {row.failed}
                </span>
            )
        },

        {
            key: "actions",
            label: "Actions",
            render: (_, row) => (
                <button
                    onClick={() => openDetails(row)}
                    className="
                    px-3
                    py-1
                    rounded
                    bg-indigo-600
                    text-white
                    text-sm
                    hover:bg-indigo-700
                "
                >
                    View
                </button>
            )
        }

    ];

    return (
        <SectionCard title="Campaign History">
            <DataTable
                columns={columns}
                rows={history.results}
                emptyText="No campaigns found"
            />

            <div className="mt-4 border-t border-gray-100 pt-4">
                <SmartPagination
                    currentPage={history.current_page}
                    totalPages={history.total_pages}
                    totalItems={history.count}
                    pageSize={history.page_size}
                    onPageChange={onPageChange}
                />
            </div>
            {selectedCampaign && (

                <CampaignDetailsModal

                    campaign={selectedCampaign}

                    onClose={closeDetails}

                />

            )}
        </SectionCard>
    );
};

export default HistoryTable;
